






















































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import { mixins } from "vue-class-component";
import ImportPage from "@/lib/import-page";
@Component({})
export default class ImportCategory extends mixins(AbpBase, ImportPage) {
  importPageName = "Category";
  current: number = 0;
  categoryFileId: number = 0;
  spinShow: boolean = false;
  get countItems() {
    return this.$store.state.categoryfile.countItems;
  }
  get countImportedItems() {
    return this.$store.state.categoryfile.countImportedItems;
  }
  get list() {
    return this.$store.state.categoryfile.itemsImported;
  }
  get loading() {
    return this.$store.state.categoryfile.loading;
  }
  activeStep(next: boolean) {
    if (next && this.current < 1) {
      this.current++;
    }
    if (!next && this.current > 0) {
      this.current--;
    }
  }
  nextStep() {
    this.activeStep(true);
  }
  backStep() {
    this.activeStep(false);
  }
  async exportToExcel() {
    await this.$store.dispatch({
      type: "categoryfile/export",
      data: this.categoryFileId,
    });
  }
  renderErrorMsgElements(errorMessage: string) {
    return Util.renderErrorMsgElements(errorMessage);
  }
  columns = [
    {
      title: this.L("ErrorMsg"),
      key: "errorMessage",
      fixed: "left",
      width: 200,
    },
    {
      title: this.L("Code"),
      key: "code",
    },
    {
      title: this.L("ParentCode"),
      key: "parentCode",
    },
    {
      title: this.L("Name"),
      key: "name",
    },
    {
      title: this.L("IsImported"),
      align: "center",
      width: 100,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Icon",
            {
              props: {
                size: 36,
                type: Util.getIsImportedIcon(params.row.isImported),
              },
            },
            ""
          ),
        ]);
      },
    },
  ];
  async created() {
    if (!this.checkSignalConnected()) return;
    if (Util.abp.signalr && Util.abp.signalr.hubs.common.state == 1) {
      Util.abp.signalr.hubs.common.on("Import.Category", (notification) => {
        this.processNotifierImportCategory(notification);
      });
    } else {
      abp.event.on("abp.signalr.connected", () => {
        Util.abp.signalr.hubs.common.on("Import.Category", (notification) => {
          this.processNotifierImportCategory(notification);
        });
      });
    }
  }
  processNotifierImportCategory(notification: any) {
    if (notification.categoryFileId == this.categoryFileId) {
      this.$store.commit({
        type: "categoryfile/processNotifier",
        data: notification,
      });
    }
  }
  resetList() {
    this.$store.commit({
      type: "categoryfile/resetList",
    });
  }
  handleBeforeUpload(file) {
    const fileExt = file.name.split(".").pop().toLocaleLowerCase();

    if (fileExt === "xlsx" || fileExt === "xls") {
      let data = new FormData();
      data.append("file", file);
      this.spinShow = true;
      try {
        this.$store
          .dispatch("categoryfile/uploadImportCategoryFile", data)
          .then((res) => {
            this.resetList();
            this.activeStep(true);
            this.categoryFileId = res;
            this.spinShow = false;
          })
          .catch(() => {
            this.spinShow = false;
          });
      } catch (error) {
        this.spinShow = false;
      }
    }
    return false;
  }
}
